import * as React from 'react';
/**
 *
 * Original name: phone
 support
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22331%3A2804
 *
 */
export const PhoneSupportSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48 13h24v3.098c7.744 1.521 14.4 4.676 19.58 9.8 4.839 4.787 7.999 10.905 9.685 18.102H107v34h-7.585c-1.817 4.644-4.404 8.708-7.836 12.102-6.104 6.04-14.26 9.343-23.83 10.46C66.962 104.216 64.32 106 60 106c-5.232 0-8-2.617-8-8s2.768-8 8-8c3.954 0 6.501 1.495 7.51 4.549C79.772 93.012 88.314 87.538 92.877 78H87V44h8.08C91.867 32.141 84.069 24.936 72 22.227V25H48v-2.827C35.791 24.838 27.91 32.061 24.675 44H33v34H13V44h5.49c1.686-7.197 4.846-13.316 9.686-18.102C33.41 20.72 40.151 17.553 48 16.05V13ZM19.48 50.48h7.04v21.04h-7.04V50.48Zm74 0h7.04v21.04h-7.04V50.48Z", fill: "currentColor" })));
